import React, { SyntheticEvent, useCallback, useEffect, useMemo, useRef, useState } from "react";

import { Form, FormField, FormGroup } from "semantic-ui-react";

import DropdownOptions from "react-lib/appcon/common/DropdownOptions";
// import { SelectedItemHandler } from "react-lib/appcon/common/SearchBoxDropdown";
// import SearchBoxWithKey from "react-lib/appcon/common/SearchBoxWithKey";

import LoadingIcon from "../HISV3/HCU/LoadingIcon";

import { FilterScheduleType } from "./sequence/ScheduleSetting";

type SearchProviderSpecialtyProps = {
  onEvent: (e: any) => void;
  divisionId?: number;
  filter?: FilterScheduleType;
  searchedItemListWithKey: any;
  specialtyOptions?: any[];
  onSearch: (filter: FilterScheduleType) => Promise<void>;
};

const SearchProviderSpecialty = (props: SearchProviderSpecialtyProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [selectedProviders, setSelectedProviders] = useState<
    NonNullable<FilterScheduleType["providers"]>
  >([]);
  const [selectedSpecialties, setSelectedSpecialties] = useState<number[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const formRef = useRef<HTMLDivElement>(null);

  const handleClickOutside = useCallback((event: MouseEvent) => {
    if (formRef.current && !formRef.current.contains(event.target as Node)) {
      setIsExpanded(false);
    }
  }, []);

  useEffect(() => {
    if (isExpanded) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [handleClickOutside, isExpanded]);

  useEffect(() => {
    setSelectedProviders(props.filter?.providers ?? []);
    setSelectedSpecialties(props.filter?.specialties ?? []);
  }, [props.filter]);

  const mapOptions = useCallback(
    (items: any[]) =>
      items.filter(Boolean).map((item) => ({
        key: item.provider_id || item.id,
        text: `${item.pre_name || ""} ${item.first_name || ""} ${item.last_name || ""} ${
          item.name || ""
        }`,
        value: item.provider_id || item.id,
      })),
    []
  );

  const selectedOptions = useMemo(
    () =>
      selectedProviders.map((item) => ({
        key: item.id,
        text: item.name,
        value: item.id,
      })),
    [selectedProviders]
  );

  const providerOptions = useMemo(() => {
    const items: Record<string, any>[] = props.searchedItemListWithKey?.Provider_SPS ?? [];

    return [...selectedOptions, ...mapOptions(items)];
  }, [props.searchedItemListWithKey, selectedOptions]);

  const filteredProviderOptions = useMemo(
    () => mapOptions(props.filter?.providers ?? []),
    [props.filter?.providers]
  );

  const handleSearchBoxClick = useCallback((e: SyntheticEvent) => {
    const input = e.target as HTMLInputElement;

    input.blur();

    setIsExpanded(true);
  }, []);

  // const handleSelect: SelectedItemHandler = (value, key, data) => {
  //   if (data) {
  //     const name = `${data.pre_name || ""} ${data.first_name || ""} ${data.last_name || ""}`;

  //     setSelectedProviders([...selectedProviders, { id: data.provider_id, name }]);
  //   }
  // };

  const handleChangeProvider = (options: Record<string, any>[]) => (e: any, data: any) => {
    const value: number[] = data.value ?? [];
    const filteredProviders = options.filter((item) => value.includes(item.value));
    const formattedProviders = filteredProviders.map((provider) => ({
      id: provider.value,
      name: provider.text,
    }));

    if (data.name === "searched") {
      void handleSearch(formattedProviders);
    } else {
      setSelectedProviders(formattedProviders);

      props.onEvent({
        message: "ItemSearch",
        params: { action: "clear", id: "SPS", type: "Provider" },
      });
    }
  };

  const handleChangeSpecialty = (e: any, data: any) => {
    setSelectedSpecialties(data.value);
  };

  const handleClear = () => {
    setSelectedSpecialties([]);
    setSelectedProviders([]);
  };

  const handleSearch = async (providers?: FilterScheduleType["providers"]) => {
    if (isLoading) {
      return;
    }

    setIsLoading(true);

    await props.onSearch({
      providers: providers ?? selectedProviders,
      specialties: selectedSpecialties,
    });

    setIsLoading(false);
    setIsExpanded(false);
  };

  return (
    <div style={{ position: "relative", width: "calc(-80.5rem + 100vw)" }}>
      <div ref={formRef}>
        <Form
          style={{
            ...(isExpanded && {
              backgroundColor: "white",
              border: "1px solid rgba(243, 130, 160, 0.5)",
            }),
            borderRadius: "9px",
            fontSize: "0.9rem",
            padding: "10px 1rem",
            position: "absolute",
            right: 0,
            top: "-28px",
            width: "100%",
            zIndex: "1",
          }}
        >
          <FormGroup inline>
            <FormField style={{ paddingRight: 0 }} width={16} inline>
              <DropdownOptions
                onEvent={props.onEvent}
                style={{ fontSize: "0.90rem", width: "100%" }}
                icon={filteredProviderOptions.length === 0 ? "search" : undefined}
                name="searched"
                open={false}
                placeholder="Select provider"
                value={(props.filter?.providers ?? []).map((option) => option.id)}
                fluid
                inline
                multiple
                search
                options={filteredProviderOptions}
                onChange={handleChangeProvider(filteredProviderOptions)}
                onFocus={handleSearchBoxClick}
              />
              {/* <SearchBoxWithKey
                onEvent={props.onEvent}
                id="CSS"
                clearable={false}
                placeholder={hasFilter ? "Filtered by Selected Provider" : "Search"}
                size="small"
                type="Provider"
                valueKey="provider_id"
                searchedItemListWithKey={props.searchedItemListWithKey}
                mapOptions={mapOptions}
                setSelected={handleSelect}
                onAdditionalUrlParams={() => ({ division: props.divisionId })}
                onFocus={handleSearchBoxClick}
                dropdownStyle={
                  hasFilter
                    ? {
                        borderColor: "var(--primary-theme-color-half)",
                        color: "var(--primary-theme-color)",
                      }
                    : {}
                }
              /> */}
            </FormField>
          </FormGroup>

          {isExpanded && (
            <>
              <FormGroup inline>
                <FormField style={{ paddingRight: 0 }} width={16} inline>
                  <label style={{ minWidth: "50px" }}>Provider</label>
                  <DropdownOptions
                    onEvent={props.onEvent}
                    id="SPS"
                    style={{ fontSize: "0.90rem", width: "100%" }}
                    iconStyle={{ display: "none" }}
                    placeholder="Select provider"
                    startSearchLength={3}
                    type="Provider"
                    value={selectedOptions.map((option) => option.value)}
                    filter
                    fluid
                    multiple
                    search
                    options={providerOptions}
                    onAdditionalUrlParams={() => ({ division: props.divisionId })}
                    onChange={handleChangeProvider(providerOptions)}
                  />
                </FormField>
              </FormGroup>
              <FormGroup inline>
                <FormField style={{ paddingRight: 0 }} width={16} inline>
                  <label style={{ minWidth: "50px" }}>Specialty</label>
                  <DropdownOptions
                    style={{ fontSize: "0.90rem", width: "100%" }}
                    placeholder="Select specialty"
                    value={selectedSpecialties}
                    filter
                    fluid
                    multiple
                    search
                    options={props.specialtyOptions}
                    onChange={handleChangeSpecialty}
                  />
                </FormField>
              </FormGroup>
              <FormGroup style={{ marginBottom: 0 }} inline>
                <FormField style={{ flex: 1 }} />
                <FormField style={{ color: "rgba(200, 85, 120, 1)", display: "flex" }}>
                  <div style={{ cursor: "pointer", marginRight: "1.5rem" }} onClick={handleClear}>
                    Clear
                  </div>

                  <div>
                    <LoadingIcon style={{ marginTop: 0 }} loading={isLoading} />
                    <label
                      style={isLoading ? {} : { cursor: "pointer" }}
                      onClick={() => {
                        void handleSearch();
                      }}
                    >
                      Search
                    </label>
                  </div>
                </FormField>
              </FormGroup>
            </>
          )}
        </Form>
      </div>
    </div>
  );
};

SearchProviderSpecialty.displayName = "SearchProviderSpecialty";

export default React.memo(SearchProviderSpecialty);
